import { Button } from '@mui/material';
import { useMenuContext } from '../context';

type Props = {
  url: string;
  label: string;
  sendToGA: (type: string, obj: any, isMultiPaths?: boolean) => void;
};

export const BookButton = ({ url, label, sendToGA }: Props) => {
  const { colors } = useMenuContext();

  return (
    <Button
      component="a"
      sx={{
        borderRadius: 1,
        background: colors.btnBg,
        color: colors.btnText,
        my: 1,
        mx: 1,
        textTransform: 'none',
        '&:hover': {
          background: colors.btnHover,
          color: colors.btnText,
        },
      }}
      onClick={() => {
        sendToGA('event', {
          eventCategory: 'BookNow',
          eventAction: 'click',
        });
      }}
      rel="noreferrer"
      target="_blank"
      href={url}
    >
      {label}
    </Button>
  );
};
